import { render } from "./ControlPanelGameInstruction.vue?vue&type=template&id=d8f2d390&scoped=true"
import script from "./ControlPanelGameInstruction.vue?vue&type=script&lang=js"
export * from "./ControlPanelGameInstruction.vue?vue&type=script&lang=js"

import "./ControlPanelGameInstruction.vue?vue&type=style&index=0&id=d8f2d390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f2d390"]])

export default __exports__